import React, { useRef } from "react";
import localeText from "../../../../locale";
import { Tag } from "primereact/tag";
import { Link } from "react-router-dom";
import "./style.css";

const LandingPlansCards = (props) => {
  const scrollContainerRef = useRef(null);

  const scrollToCard = (direction) => {
    if (!scrollContainerRef.current) return;

    const container = scrollContainerRef.current;
    const cardWidth = container.querySelector(".card-wrapper").offsetWidth;
    const scrollAmount = direction === "left" ? -cardWidth - 16 : cardWidth + 16;

    container.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });
  };

  const plans = [
    {
      key: "partner",
      profile: localeText("lp2Profile"),
      name: "Partner",
      badge: localeText("lp2BadgeProSilver"),
      badgeBg: "var(--extra-green-dark)",
      cashback: localeText("lp2CashbackPartner"),
      description: localeText("partnerPlanDescription"),
      features: props.featuresCard1,
      cta: localeText("lp2CtaSelect"),
      to: "/businesspartner",
      highlight: false,
    },
    {
      key: "seller",
      profile: localeText("lp2Profile"),
      name: "Seller",
      badge: localeText("lp2BadgeMostPopular"),
      badgeBg: "var(--extra-mint)",
      badgeColor: "var(--extra-green)",
      cashback: localeText("lp2CashbackSeller"),
      description: localeText("sellerPlanDescription"),
      features: props.featuresCard2,
      cta: localeText("lp2CtaSelect"),
      to: "/seller",
      highlight: true,
    },
    {
      key: "manager",
      profile: localeText("lp2Profile"),
      name: "Manager",
      badge: localeText("lp2BadgeGeoGold"),
      badgeBg: "var(--extra-yellow)",
      badgeColor: "var(--extra-ink)",
      cashback: localeText("lp2CashbackManager"),
      description: localeText("managerPlanDescription"),
      features: props.featuresCard3,
      cta: localeText("lp2CtaSelect"),
      to: "/areamanager",
      highlight: false,
      borderColor: "var(--extra-yellow)",
    },
    {
      key: "store",
      profile: localeText("lp2Profile"),
      name: "Store",
      badge: localeText("lp2BadgeFree"),
      badgeBg: "var(--extra-green)",
      badgeColor: "#fff",
      cashback: localeText("lp2StoreItem3Title"),
      description: localeText("lp2StorePlanDesc"),
      features: [
        localeText("lp2FeatureFreeSignup"),
        localeText("lp2FeatureGeoAccount"),
        localeText("lp2FeatureMapCertification"),
      ],
      cta: localeText("lp2CtaCertifyStore"),
      to: "/storeregister",
      highlight: false,
    },
    {
      key: "customer",
      profile: localeText("lp2Profile"),
      name: "Customer",
      badge: localeText("lp2BadgeFree"),
      badgeBg: "var(--extra-green)",
      badgeColor: "#fff",
      cashback: localeText("lp2CashbackCustomer"),
      description: localeText("lp2CustomerPlanDesc"),
      features: [
        localeText("lp2FeatureFreeSignup"),
        localeText("lp2FeatureEligibleCashback"),
        localeText("lp2FeatureExtracreditWallet"),
      ],
      cta: localeText("lp2CtaCreateAccount"),
      to: "/specialcustomer",
      highlight: false,
    },
  ];

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <button
        onClick={() => scrollToCard("left")}
        className="plans-arrow plans-arrow-left bg-white border-circle hidden md:flex"
        style={{
          width: "48px",
          height: "48px",
          border: "1px solid var(--extra-line)",
        }}
        aria-label="Previous card"
      >
        <i className="pi pi-chevron-left" style={{ color: "var(--extra-ink)" }}></i>
      </button>
      <button
        onClick={() => scrollToCard("right")}
        className="plans-arrow plans-arrow-right bg-white border-circle hidden md:flex"
        style={{
          width: "48px",
          height: "48px",
          border: "1px solid var(--extra-line)",
        }}
        aria-label="Next card"
      >
        <i className="pi pi-chevron-right" style={{ color: "var(--extra-ink)" }}></i>
      </button>
      <div ref={scrollContainerRef} className="card-container pt-6 pb-3 md:pb-6 h-full">
        {plans.map((plan) => (
          <div
            key={plan.key}
            className="border-round-xl p-0 py-3 card-wrapper flex flex-column relative landing-card-hover plan-card-lift"
            style={{
              boxShadow: "0px 0px 40px #5F58521A",
              backgroundColor: plan.highlight ? "var(--extra-green-dark)" : "#fff",
              ...(plan.highlight
                ? { border: "1px solid var(--extra-green-dark)" }
                : plan.borderColor
                  ? { border: `1px solid ${plan.borderColor}` }
                  : {}),
            }}
          >
            <div className="p-5 pb-0 flex flex-column gap-1">
              <div className="flex align-items-start justify-content-between gap-2">
                <div
                  className="font-medium text-lg"
                  style={{ color: plan.highlight ? "#fff" : "var(--extra-body)" }}
                >
                  {plan.profile}
                </div>
                <div className="flex align-items-center gap-2">
                  {plan.tag && (
                    <Tag
                      className="font-medium"
                      value={plan.tag}
                      style={{
                        backgroundColor: "white",
                        color: "var(--extra-green)",
                        borderRadius: "999px",
                        whiteSpace: "nowrap",
                      }}
                    />
                  )}
                  <Tag
                    rounded
                    className="font-semibold"
                    value={plan.badge}
                    style={{
                      backgroundColor: plan.badgeBg,
                      color: plan.badgeColor || "#fff",
                      fontSize: "0.8rem",
                      padding: "0.3rem 0.9rem",
                      whiteSpace: "nowrap",
                      borderRadius: "999px",
                    }}
                  />
                </div>
              </div>
              <div
                className="font-bold text-4xl title"
                style={{ color: plan.highlight ? "#fff" : "var(--extra-ink)" }}
              >
                {plan.name}
              </div>
              <div className="mt-0">
                <div
                  className="text-sm mt-2"
                  style={{ color: plan.highlight ? "rgba(255,255,255,0.8)" : "var(--extra-body)" }}
                >
                  {plan.cashback}
                </div>
                <div
                  className="text-base mt-3"
                  style={{
                    color: plan.highlight ? "#fff" : "var(--extra-ink)",
                  }}
                >
                  {plan.description}
                </div>
              </div>
            </div>
            <div className="p-5 flex flex-column justify-content-between" style={{ flex: 1 }}>
              <div>
                {plan.features.map((feature, index) => (
                  <div
                    key={index}
                    className="flex align-items-center gap-3 py-3"
                    style={{
                      borderBottom:
                        index < plan.features.length - 1
                          ? `1px solid ${plan.highlight ? "rgba(255,255,255,0.15)" : "var(--extra-line)"}`
                          : "none",
                    }}
                  >
                    <i
                      className="pi pi-check"
                      style={{
                        color: plan.highlight ? "var(--extra-mint)" : "var(--extra-green)",
                        fontSize: "1rem",
                      }}
                    ></i>
                    <span
                      className="text-base"
                      style={{ color: plan.highlight ? "#fff" : "var(--extra-ink)" }}
                    >
                      {feature}
                    </span>
                  </div>
                ))}
              </div>
              <Link
                to={plan.to}
                className="w-full flex justify-content-center p-3 font-medium border-round-lg mt-4 p-button p-no-outline"
                style={{
                  backgroundColor: plan.highlight ? "var(--extra-yellow)" : "transparent",
                  color: plan.highlight ? "var(--extra-ink)" : "var(--extra-green)",
                  border: plan.highlight ? "none" : "2px solid var(--extra-green)",
                }}
              >
                {plan.cta}
              </Link>
            </div>
          </div>
        ))}
      </div>
      <div className="flex md:hidden justify-content-center align-items-center gap-4 mt-2">
        <button
          onClick={() => scrollToCard("left")}
          className="nav-button bg-white border-circle"
          style={{ width: "48px", height: "48px", border: "1px solid var(--extra-mint)" }}
          aria-label="Previous card"
        >
          <i className="pi pi-chevron-left" style={{ color: "var(--extra-ink)" }}></i>
        </button>
        <button
          onClick={() => scrollToCard("right")}
          className="nav-button bg-white border-circle"
          style={{ width: "48px", height: "48px", border: "1px solid var(--extra-mint)" }}
          aria-label="Next card"
        >
          <i className="pi pi-chevron-right" style={{ color: "var(--extra-ink)" }}></i>
        </button>
      </div>
    </div>
  );
};

export default LandingPlansCards;
